import { ref as $, inject as E, computed as n, unref as u, watchEffect as w, resolveComponent as I, openBlock as f, createElementBlock as m, normalizeClass as N, normalizeStyle as v, createElementVNode as h, mergeProps as P, createTextVNode as b, withDirectives as y, createVNode as x, withModifiers as C, vShow as g, renderSlot as z, toDisplayString as A, createCommentVNode as j } from "vue";
import { useCssVar as M } from "./design-system.es125.js";
import T from "./design-system.es58.js";
/* empty css                    */
/* empty css                    */
import F from "./design-system.es128.js";
const G = {
  name: "DsCheckbox",
  components: {
    Icon: T
  },
  props: {
    /**
     * Boolean checked value.
     */
    modelValue: Boolean,
    /**
     * String value that appears next to the checkbox.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Boolean value that controls the error state of the checkbox.
     */
    error: Boolean,
    /**
     * Boolean value that determines whether a user can interact with the checkbox.
     */
    disabled: Boolean,
    /**
     * Displays whether or not the checkboxes in a group are partially selected.
     */
    partial: Boolean,
    /**
     * Determines whether or not the checkbox will have a background color.
     */
    task: Boolean,
    /**
     * Custom hex color for the checkbox background when checked. Only when not in error or disabled state.
     */
    color: {
      type: String,
      default: ""
    },
    /**
     * Custom hex color for the checkbox border. Only when not in error state.
     */
    borderColor: {
      type: String,
      default: ""
    },
    /**
     * Custom hex color for the indicator icon when checked. Only when not in disabled state.
     */
    iconColor: {
      type: String,
      default: ""
    },
    /**
     * Required field for validation purposes
     */
    required: Boolean
  },
  emits: ["update:modelValue"],
  setup(r, { emit: l, slots: t }) {
    const o = $(null), a = E("dsCheckbox", null), s = n(() => a ? u(a.checked) : r.modelValue), i = n(() => a ? u(a.disabled) : r.disabled), d = n(() => a ? u(a.error) : r.error), S = M("--ds-checkbox-tabindex", o), V = n(() => S.value === "-1" ? {
      "aria-hidden": !0,
      tabindex: -1
    } : null), B = n(() => {
      const e = {};
      return d.value || i.value || (s.value && r.color && (e.backgroundColor = r.color), r.borderColor && (e.borderColor = r.borderColor)), e;
    }), D = n(() => {
      const e = {};
      return i.value || r.iconColor && (e.color = r.iconColor), e;
    }), k = n(() => i.value ? "disabled" : d.value ? "error" : r.task ? "task" : "default"), _ = n(() => {
      const e = s.value ? `--ds-checkbox-${k.value}-checked` : `--ds-checkbox-${k.value}`, c = "--ds-checkbox-current";
      return {
        [`${c}-color`]: `var(${e}-color)`,
        [`${c}-border-color`]: `var(${e}-border-color)`,
        [`${c}-background-color`]: `var(${e}-background-color)`,
        [`${c}-hover-color`]: `var(${e}-hover-color, var(${e}-color))`,
        [`${c}-hover-border-color`]: `var(${e}-hover-border-color, var(${e}-border-color))`,
        [`${c}-hover-background-color`]: `var(${e}-hover-background-color, var(${e}-background-color))`,
        [`${c}-active-color`]: `var(${e}-active-color, var(${e}-color))`,
        [`${c}-active-border-color`]: `var(${e}-active-border-color, var(${e}-border-color))`,
        [`${c}-active-background-color`]: `var(${e}-active-background-color, var(${e}-background-color))`
      };
    });
    function q() {
      r.disabled || l("update:modelValue", !r.modelValue);
    }
    return w(() => {
      var e;
      (e = a == null ? void 0 : a.registerCheckbox) == null || e.call(a, o.value);
    }), {
      el: o,
      isChecked: s,
      isDisabled: i,
      isError: d,
      boxStyle: B,
      iconStyle: D,
      styles: _,
      checkboxAttrs: V,
      slots: t,
      change: q
    };
  }
}, H = ["data-qa"], J = { class: "checkbox-container" }, K = ["value", "disabled", "required"], L = {
  key: 0,
  class: "label-container"
};
function O(r, l, t, o, a, s) {
  const i = I("Icon");
  return f(), m("label", {
    ref: "el",
    class: N(["checkbox ds-checkbox", {
      selected: o.isChecked,
      partial: t.partial,
      error: o.isError,
      disabled: o.isDisabled,
      task: t.task,
      "ds-checkbox--checked": o.isChecked,
      "ds-checkbox--disabled": o.isDisabled
    }]),
    style: v(o.styles),
    "data-qa": t.label
  }, [
    h("div", J, [
      h("input", P({
        type: "checkbox",
        value: o.isChecked,
        disabled: o.isDisabled,
        required: t.required,
        style: o.boxStyle
      }, o.checkboxAttrs, {
        onChange: l[0] || (l[0] = (...d) => o.change && o.change(...d))
      }), null, 16, K),
      l[3] || (l[3] = b()),
      y(x(i, {
        name: "check",
        class: "box-icon",
        style: v(o.iconStyle),
        onClick: l[1] || (l[1] = C(() => {
        }, ["stop"]))
      }, null, 8, ["style"]), [
        [g, o.isChecked && !t.partial]
      ]),
      l[4] || (l[4] = b()),
      y(x(i, {
        name: "minus",
        class: "box-icon",
        style: v(o.iconStyle),
        onClick: l[2] || (l[2] = C(() => {
        }, ["stop"]))
      }, null, 8, ["style"]), [
        [g, o.isChecked && t.partial]
      ])
    ]),
    l[5] || (l[5] = b()),
    o.slots.default || t.label ? (f(), m("div", L, [
      z(r.$slots, "default", {}, () => [
        b(A(t.label), 1)
      ], !0)
    ])) : j("", !0)
  ], 14, H);
}
const Z = /* @__PURE__ */ F(G, [["render", O], ["__scopeId", "data-v-40405407"]]);
export {
  Z as default
};
//# sourceMappingURL=design-system.es44.js.map
